<script setup lang="ts">
import type { MenuItemRecord } from '~/types/datocms'

interface MenuListProps {
  data: MenuItemRecord[]
  invertColors?: boolean
}

const props = withDefaults(defineProps<MenuListProps>(), {
  invertColors: false
})

// Filter top level items
const parents = computed(() =>
  props.data.filter((item) => item.parent === null && !item.excludeFromMainMenu)
)
</script>

<template>
  <nav
    class="fixed left-0 top-0 flex h-screen w-full transform-gpu flex-col justify-center gap-6 text-center lg:absolute lg:left-1/2 lg:top-10 lg:flex lg:h-auto lg:w-fit lg:-translate-x-1/2 lg:flex-row"
    role="navigation"
  >
    <span
      v-for="(item, idx) in parents"
      :key="idx"
      class="pointer-events-auto block overflow-hidden"
    >
      <MenuListItem :idx="idx" :data="item" :invert-colors="invertColors" />
    </span>
  </nav>
</template>
